import { CALL_API } from "admin/middlewares/api";

export const LOAN_LIST_GET_REQUEST = "LOAN_LIST_GET_REQUEST";
export const LOAN_LIST_GET_SUCCESS = "LOAN_LIST_GET_SUCCESS";
export const LOAN_LIST_GET_ERROR = "LOAN_LIST_GET_ERROR";

export function get_loans(stage) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loans/bystage?stage=" + stage,
      authenticatedRequest: true,
      types: [
        LOAN_LIST_GET_REQUEST,
        LOAN_LIST_GET_SUCCESS,
        LOAN_LIST_GET_ERROR,
      ],
      additionalData: stage,
    },
  };
}

export function get_loans_for_account(accountId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loans/byaccount?accountId=" + accountId,
      authenticatedRequest: true,
      types: [
        LOAN_LIST_GET_REQUEST,
        LOAN_LIST_GET_SUCCESS,
        LOAN_LIST_GET_ERROR,
      ],
    },
  };
}

export const LOAN_LIST_CHANGE_PAGE = "LOAN_LIST_CHANGE_PAGE";

export function change_loan_list_page(page) {
  return {
    type: LOAN_LIST_CHANGE_PAGE,
    page,
  };
}

export const LOAN_LIST_CHANGE_FILTER = "LOAN_LIST_CHANGE_FILTER";

export function change_loan_list_filter(
  key,
  value,
  type,
  valueKey,
  prevFilter,
) {
  let filter = prevFilter;
  if (!filter) filter = {};

  if (type === "dropdown") {
    // checkbox checked
    let filterObj = filter[key];
    if (!filterObj) filterObj = {};

    if (value) {
      // add valueKey
      filterObj[valueKey] = true;
    } else {
      // remove valueKey
      delete filterObj[valueKey];
    }

    filter[key] = filterObj;
  } else if (type === "date") {
    filter[key] = value;
  } else {
    filter[key] = value;
  }

  return {
    type: LOAN_LIST_CHANGE_FILTER,
    filter,
  };
}

export const LOAN_REPAYMENT_REQUEST = "LOAN_REPAYMENT_REQUEST";
export const LOAN_REPAYMENT_SUCCESS = "LOAN_REPAYMENT_SUCCESS";
export const LOAN_REPAYMENT_ERROR = "LOAN_REPAYMENT_ERROR";

export function full_repayment(loanId, accountId, date, amount) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loans/repayment/create",
      authenticatedRequest: true,
      method: "POST",
      // The amount needs to be "casted" to a string so it maps correctly in BE (for some reason we have a string there)
      data: {
        CreditId: loanId,
        Amount: amount.toString(),
        Date: date,
        AccountId: accountId,
      },
      types: [
        LOAN_REPAYMENT_REQUEST,
        LOAN_REPAYMENT_SUCCESS,
        LOAN_REPAYMENT_ERROR,
      ],
    },
  };
}

export const GET_REPAYMENT_REQUEST = "GET_REPAYMENT_REQUEST";
export const GET_REPAYMENT_SUCCESS = "GET_REPAYMENT_SUCCESS";
export const GET_REPAYMENT_ERROR = "GET_REPAYMENT_ERROR";

export function get_full_repayment(loanId, date) {
  return {
    [CALL_API]: {
      endpoint:
        "/api/admin/loans/fullrepayment?loanId=" + loanId + "&date=" + date,
      authenticatedRequest: true,
      method: "GET",
      data: { CreditId: loanId },
      types: [
        GET_REPAYMENT_REQUEST,
        GET_REPAYMENT_SUCCESS,
        GET_REPAYMENT_ERROR,
      ],
    },
  };
}

export const GET_PERFORMING_REQUEST = "GET_PERFORMING_REQUEST";
export const GET_PERFORMING_SUCCESS = "GET_PERFORMING_SUCCESS";
export const GET_PERFORMING_ERROR = "GET_PERFORMING_ERROR";

export function get_performing_for_dashboard() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loans/bystage?stage=Performing",
      authenticatedRequest: true,
      types: [
        GET_PERFORMING_REQUEST,
        GET_PERFORMING_SUCCESS,
        GET_PERFORMING_ERROR,
      ],
    },
  };
}

export const REMOVE_FEES_REQUEST = "REMOVE_FEES_REQUEST";
export const REMOVE_FEES_SUCCESS = "REMOVE_FEES_SUCCESS";
export const REMOVE_FEES_ERROR = "REMOVE_FEES_ERROR";

export function remove_fees(data, removalType) {
  let url = "/api/admin/invoices/";
  switch (removalType) {
    case "all":
      url += "fees/remove-all";
      break;
    case "byType":
      url += "fees/remove-by-type";
      break;
    case "byTypeOnDate":
      url += "fees/remove-by-type-on-date";
      break;
    case "allOnDate":
      url += "fees/remove-all-on-date";
      break;
    case "allSinceDate":
      url += "fees/remove-all-since-date";
      break;
    case "byTypeSinceDate":
      url += "fees/remove-by-type-since-date";
      break;
  }

  return {
    [CALL_API]: {
      endpoint: url,
      authenticatedRequest: true,
      data: data,
      method: "POST",
      types: [REMOVE_FEES_REQUEST, REMOVE_FEES_SUCCESS, REMOVE_FEES_ERROR],
    },
  };
}

export const LOAN_STATUS_UPDATE_REQUEST = "LOAN_STATUS_UPDATE_REQUEST";
export const LOAN_STATUS_UPDATE_SUCCESS = "LOAN_STATUS_UPDATE_SUCCESS";
export const LOAN_STATUS_UPDATE_ERROR = "LOAN_STATUS_UPDATE_ERROR";

export function update_loan_status(creditId) {
  let url = "/api/admin/loans/regret";

  return {
    [CALL_API]: {
      endpoint: url,
      authenticatedRequest: true,
      data: { LoanId: creditId },
      method: "POST",
      types: [
        LOAN_STATUS_UPDATE_REQUEST,
        LOAN_STATUS_UPDATE_SUCCESS,
        LOAN_STATUS_UPDATE_ERROR,
      ],
    },
  };
}

export const LOAN_SET_TO_DISPUTED_REQUEST = "LOAN_SET_TO_DISPUTED_REQUEST";
export const LOAN_SET_TO_DISPUTED_SUCCESS = "LOAN_SET_TO_DISPUTED_SUCCESS";
export const LOAN_SET_TO_DISPUTED_ERROR = "LOAN_SET_TO_DISPUTED_ERROR";

export function set_loan_to_disputed(loanId, reason) {
  let url = "/api/admin/loans/set-disputed";

  return {
    [CALL_API]: {
      endpoint: url,
      authenticatedRequest: true,
      data: { LoanId: loanId, Text: reason },
      method: "POST",
      types: [
        LOAN_SET_TO_DISPUTED_REQUEST,
        LOAN_SET_TO_DISPUTED_SUCCESS,
        LOAN_SET_TO_DISPUTED_ERROR,
      ],
    },
  };
}

export const LOAN_SET_TO_UNDISPUTED_REQUEST = "LOAN_SET_TO_UNDISPUTED_REQUEST";
export const LOAN_SET_TO_UNDISPUTED_SUCCESS = "LOAN_SET_TO_UNDISPUTED_SUCCESS";
export const LOAN_SET_TO_UNDISPUTED_ERROR = "LOAN_SET_TO_UNDISPUTED_ERROR";

export function set_loan_to_undisputed(loanId, reason) {
  let url = "/api/admin/loans/set-undisputed";

  return {
    [CALL_API]: {
      endpoint: url,
      authenticatedRequest: true,
      data: { LoanId: loanId, Text: reason },
      method: "POST",
      types: [
        LOAN_SET_TO_UNDISPUTED_REQUEST,
        LOAN_SET_TO_UNDISPUTED_SUCCESS,
        LOAN_SET_TO_UNDISPUTED_ERROR,
      ],
    },
  };
}
export const LOAN_SET_INVOICE_METHOD_REQUEST =
  "LOAN_SET_INVOICE_METHOD_REQUEST";
export const LOAN_SET_INVOICE_METHOD_SUCCESS =
  "LOAN_SET_INVOICE_METHOD_SUCCESS";
export const LOAN_SET_INVOICE_METHOD_ERROR = "LOAN_SET_INVOICE_METHOD_ERROR";

export function set_invoice_method(loanGuid, method) {
  let url = "/api/admin/loans/set-invoice-method";

  return {
    [CALL_API]: {
      endpoint: url,
      authenticatedRequest: true,
      data: { LoanGuid: loanGuid, InvoiceMethod: method },
      method: "POST",
      types: [
        LOAN_SET_INVOICE_METHOD_REQUEST,
        LOAN_SET_INVOICE_METHOD_SUCCESS,
        LOAN_SET_INVOICE_METHOD_ERROR,
      ],
    },
  };
}

export const LOAN_SET_PPI_STATUS_REQUEST = "LOAN_SET_PPI_STATUS_REQUEST";
export const LOAN_SET_PPI_STATUS_SUCCESS = "LOAN_SET_PPI_STATUS_SUCCESS";
export const LOAN_SET_PPI_STATUS_ERROR = "LOAN_SET_PPI_STATUS_ERROR";

export function set_ppi_subscription_status(loanGuid, isActive) {
  let url = "/api/admin/loans/set-ppi-status-active-from-tomorrow";

  return {
    [CALL_API]: {
      endpoint: url,
      authenticatedRequest: true,
      data: { LoanId: loanGuid, Active: isActive },
      method: "POST",
      types: [
        LOAN_SET_PPI_STATUS_REQUEST,
        LOAN_SET_PPI_STATUS_SUCCESS,
        LOAN_SET_PPI_STATUS_ERROR,
      ],
    },
  };
}
